// extracted by mini-css-extract-plugin
export default {"header-title":"title_header-title__Q14TD","header-fit-title":"title_header-fit-title__chCVR"};